import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useQuestions } from "src/context/QuestionsProvider";
import QualificationCard from "./components/QualificationCard";
import InformationCard from "./components/InformationCard/InformationCard";

interface Props {
  onNext: () => void;
}

const AmhPlan = ({ onNext }: Props) => {
  const title = useQuestions((q) => q.title);
  const { t } = useTranslation();
  const page = "amh-plan";

  return (
    <Stack gap={3}>
      <Typography variant="h4">{title}</Typography>
      <InformationCard
        onNavigate={onNext}
        title={t(`${page}.card-1.title`, "Anxiety & depression results")}
        text={t(
          `${page}.card-1.text`,
          "Your scores help your provider understand exactly how you’ve been feeling so they can choose the right path forward."
        )}
      />
      <InformationCard
        onNavigate={onNext}
        title={t(`${page}.card-2.title`, "Medication preferences")}
        text={t(
          `${page}.card-2.text`,
          "If you have a preference, your provider will take it into account and recommend the option that feels right for you."
        )}
      />
      <InformationCard
        onNavigate={onNext}
        title={t(`${page}.card-3.title`, "Ease of starting treatment")}
        text={t(
          `${page}.card-3.text`,
          "Your provider will choose a medication that is easy to begin and designed to minimize early side effects."
        )}
      />
      <QualificationCard onNavigate={onNext} />
    </Stack>
  );
};

export default AmhPlan;
